import { render } from "./SvgLogo.vue?vue&type=template&id=6dd05ac0&scoped=true"
import script from "./SvgLogo.vue?vue&type=script&lang=js"
export * from "./SvgLogo.vue?vue&type=script&lang=js"

import "./SvgLogo.vue?vue&type=style&index=0&id=6dd05ac0&scoped=true&lang=css"

import exportComponent from "/Users/medvedevpavel/Documents/code/lb_advice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd05ac0"]])

export default __exports__